import s from './styles.module.css'
import Section from '../index'
import CardList from '../card-list'
import Card from '../card'

const onlySpecificCategory = (post, categoryName) =>
  post.fields.categories.filter(({ fields }) => fields.name === categoryName)

const PostsByCategories = ({ postsByCategory }) => {
  return (
    <>
      {Object.keys(postsByCategory).map(category => (
        <div key={`${category}-section`} className={s.relatedSection}>
          <Section
            title={postsByCategory[category].name}
            slug={postsByCategory[category].slug}
            className={s.related}>
            <CardList className={s.relatedPosts}>
              {postsByCategory[category].posts.map(post => {
                return (
                  <Card
                    key={`category-${post.sys.id}`}
                    className={s.relatedPost}
                    categories={onlySpecificCategory(post, category)}
                    post={post}
                  />
                )
              })}
            </CardList>
          </Section>
        </div>
      ))}
    </>
  )
}

export default PostsByCategories
